import { useTranslation } from "hhn-commons";
import { InputField } from "./AddPatientGroup.style";

type InsuranceFieldProps = {
  insurance: string;
  onSetInsurance: (insurance: string) => void;
};
export const InsuranceField = ({
  insurance,
  onSetInsurance,
}: InsuranceFieldProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });
  return (
    <InputField
      id="insurance"
      label={tNs("insuranceLabel")}
      type="text"
      variant="standard"
      value={insurance}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onSetInsurance(e.target.value);
      }}
      slotProps={{
        inputLabel: { shrink: !!insurance },
        htmlInput: {
          "data-testid": "insurance",
        },
      }}
    />
  );
};
